<template>
  <div class="error-wrapper px-5">
    <div class="error-content text-center">
      <img src="https://file.usail.es/static/usail-logo-color.svg" alt="USAIL" class="mb-4" />
      <h1 class="display-2 mb-3 primary--text">
        {{ $t('message.no_services.title') }}
      </h1>
      <p class="subheading font-weight-light">
        {{ $t('message.no_services.paragraph') }}
      </p>

      <v-btn :to="{ name: 'support' }" depressed color="primary">{{ $t('message.see_contact_information') }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoServices'
}
</script>

<style lang="scss" scoped>
.error-wrapper {
  background: url('../assets/no-map-bg.svg') no-repeat center center fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .error-content {
    max-width: 400px;
  }

  img {
    max-width: 80%;
  }
}
</style>
